query TravelAuthorizationStampPrivileges{

travelAuthorizationStampPrivileges {
    isStampingAllowed
  }
}